// Types
export const INSERIR_DADOS_ACESSO = "login/INSERIR_DADOS_ACESSO";
export const RENOVAR_DADOS_ACESSO = "login/RENOVAR_DADOS_ACESSO";
export const LIMPAR_DADOS_ACESSO = "login/LIMPAR_DADOS_ACESSO";
export const ATUALIZAR_TEMPO_EXPIRACAO = "login/ATUALIZAR_TEMPO_EXPIRACAO";
export const TROCAR_EMPRESA = "login/TROCAR_EMPRESA";

// Reducer
export const INITIAL_STATE = {
  usuario: null,
  sessaoExpirada: false
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case INSERIR_DADOS_ACESSO:
      return {
        ...state,
        usuario: action.payload,
        sessaoExpirada: false,
        trocandoEmpresa: false
      };
    case RENOVAR_DADOS_ACESSO:
      state.usuario.administrador = action.payload.administrador;
      state.usuario.empresa = action.payload.empresa;
      state.usuario.expiracaoTokenEmMinutos = action.payload.expiracaoTokenEmMinutos;
      state.usuario.id = action.payload.id;
      state.usuario.login = action.payload.login;
      state.usuario.nome = action.payload.nome;
      state.usuario.perfilUsuario = action.payload.perfilUsuario;
      state.usuario.sigla = action.payload.sigla;
      state.usuario.listaEmpresaAcesso = action.payload.listaEmpresaAcesso;
      state.usuario.permiteTrocaEmpresa = action.payload.permiteTrocaEmpresa;
      state.sessaoExpirada = false;

      return {
        ...state
      };
    case LIMPAR_DADOS_ACESSO:
      return { ...INITIAL_STATE, sessaoExpirada: true, usuario: null };
    case ATUALIZAR_TEMPO_EXPIRACAO:
      state.usuario.expiracaoTokenEmMinutos = action.payload;
      return {
        ...state
      };
    case TROCAR_EMPRESA:
      state.usuario.administrador = action.payload.administrador;
      state.usuario.empresa = action.payload.empresa;
      state.usuario.expiracaoTokenEmMinutos = action.payload.expiracaoTokenEmMinutos;
      state.usuario.id = action.payload.id;
      state.usuario.login = action.payload.login;
      state.usuario.nome = action.payload.nome;
      state.usuario.perfilUsuario = action.payload.perfilUsuario;
      state.usuario.permiteTrocaEmpresa = action.payload.permiteTrocaEmpresa;
      state.usuario.listaEmpresaAcesso = action.payload.listaEmpresaAcesso;
      state.usuario.sigla = action.payload.sigla;
      state.sessaoExpirada = false;
      state.trocandoEmpresa = true;
      return {
        ...state
      };

    default:
      return state;
  }
}

// Action creators
export const inserirDadosAcesso = usuario => {
  return {
    type: INSERIR_DADOS_ACESSO,
    payload: usuario
  };
};

export const renovarDadosAcesso = usuario => {
  return {
    type: RENOVAR_DADOS_ACESSO,
    payload: usuario
  };
};

export const atualizarTempoExpiracaoToken = minutos => {
  return {
    type: ATUALIZAR_TEMPO_EXPIRACAO,
    payload: minutos
  };
};

export const limparDadosAcesso = () => {
  return {
    type: LIMPAR_DADOS_ACESSO
  };
};

export const trocarEmpresa = usuario => {
  return {
    type: TROCAR_EMPRESA,
    payload: usuario
  };
};
